import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-11.707-.707a1 1 0 0 1 1.414 0L11 12.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414Z" /></svg>;
const ForwardRef = forwardRef(SvgSuccess);
export default ForwardRef;